export const APP_INSIGHTS_DATA_TRENDING = {
  // [DT] = Data Trending
  GET_TRENDINGS: `[DT] GET TRENDINGS`,
  GET_TRENDINGS_SUCCESS: `[DT] GET TRENDINGS SUCCESS`,
  GET_TRENDINGS_ERROR: `[DT] GET TRENDINGS ERROR`,
};
